import { TASK_PAGE_SIZE } from "@/config";
import { CouponPayload } from "@/types";
import { API } from "@/utils/api";

/* Get all tasks of a user */
export const adminGetAllTasks = async (
  userId: string,
  showArchived: boolean = false,
  offset: number = 0,
  size: number = TASK_PAGE_SIZE,
) => {
  const response = await API().get(
    `/admin/tasks/${userId}?offset=${offset}&size=${size}&showarchived=${showArchived}`,
  );
  return response.data.data;
};

export const adminGetAllProjects = async (userId: string) => {
  const response = await API().get(`/admin/projects/${userId}`);
  return response.data.data.projects;
};

/* Admin gets all tasks of a user */
export const adminGetAllUsers = async () => {
  const response = await API().get(`/admin/users`);
  return response.data.data.users;
};

/* Admin gets all tasks of a user */
export const adminGetOneUser = async (userId: string) => {
  const response = await API().get(`/admin/user/${userId}`);
  return response.data.data.user;
};

export const adminUpdateUser = async (
  userPayload: {
    username: string;
    email: string;
    plan: string;
    balance: number;
    certCredit: number;
    isDisabled: boolean;
  },
  userId: string,
) => {
  const response = await API().put(`/admin/user/${userId}`, userPayload);
  return response.data;
};
export const adminCreateUser = async (userPayload: {
  username: string;
  organization: string;
  email: string;
  password: string;
  plan: string;
  balance: number;
  certCredit: number;
}) => {
  const response = await API().put(`/admin/new_user`, userPayload);
  return response.data;
};

/* Admin gets statistics of users */
export const adminGetUserStatistics = async () => {
  const response = await API().get(`/admin/statistics/users`);
  return response.data.data.statistics;
};

/* Admin gets statistics of users */
export const adminGetTaskStatistics = async () => {
  const response = await API().get(`/admin/statistics/tasks`);
  return response.data.data.statistics;
};

/* Admin gets statistics of users */
export const adminGetSveStatistics = async () => {
  const response = await API().get(`/admin/statistics/sves`);
  return response.data.data.statistics;
};

export const adminGetAllRunningBots = async () => {
  const response = await API().get(`/admin/bots`);
  return response.data.data.bots || [];
};

export const adminGetBotTemplates = async () => {
  const response = await API().get(`/admin/bot_templates`);
  return response.data.data.botTemplates || [];
};

export const adminUpdateBotTemplates = async () => {
  const response = await API().get(`/admin/update_bot_templates`);
  return response.data.data.botTemplates || [];
};

export const updateAndResetBotsUnderTemplate = async (
  botTemplateId: string,
) => {
  const response = await API().get(`/admin/reset_bots/${botTemplateId}`);
  return response.data;
};

export const adminGetCoupons = async () => {
  const response = await API().get(`/admin/coupons`);

  return response.data.data.coupons;
};

export const adminCreateCoupon = async (payload: CouponPayload) => {
  const response = await API().post(`/admin/coupon`, payload);
  return response.data;
};

export const adminUpdateCoupon = async (payload: CouponPayload) => {
  const response = await API().put(`/admin/coupon`, payload);
  return response.data;
};

/* Delete user info */
export const adminDeleteUser = async (userId: string) => {
  const response = await API().delete(`/admin/user/${userId}`);
  return response.data;
};
